var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 0.081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    transform: "translate(0 -0.081)",
    fill: "#1b2737",
    stroke: "#fff",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 12.8,
    height: 1.8,
    rx: 0.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    transform: "translate(0 4.919)",
    fill: "#1b2737",
    stroke: "#fff",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 12.8,
    height: 1.8,
    rx: 0.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    transform: "translate(0 9.919)",
    fill: "#1b2737",
    stroke: "#fff",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 2,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 12.8,
    height: 1.8,
    rx: 0.9,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/group3.637266cc190cbc1b98cb94f0e275067a.svg";
export { ForwardRef as ReactComponent };